module.exports = __webpack_public_path__ + "static/media/stories.7517d77f.jpg";